import { useStore } from 'zustand'
import { getOrCreateInvestigationsStore } from '@/stores/investigations-store'
import type { SourceSnippet } from '@/types/source-snippet'

const EMPTY: SourceSnippet[] = []

export function useSourceSnippets(caseId: string) {
  const store = getOrCreateInvestigationsStore({ caseId })
  return useStore(store, state => {
    const view =
      state.transient?.graphView ?? state.saved.find(item => item.id === state.activeId)?.graphView
    return view?.snippets ?? EMPTY
  })
}
